<template>
    <div>
        <forms
                :settings="settings"
                @onFormButtonClick="onFormButtonClick"
        ></forms>
    </div>
</template>

<script>
import axios from "axios";
import toastr from 'toastr';
import Forms from "@/components/form/Forms";
export default {
    name: "RacunZaUlpatuForma",
    components:{ Forms },
    props:{
        disabled:{
            type: Boolean,
            default: false
        },
        id:{
            default: null
        },
        modal:{
            type: Boolean,
            default: false
        },
        action: {
            type: String
        }
    },
    data(){
        return {
            settings: {},
            errors: {},
            route: '/postavke/racuni-za-uplate',
            url: 'racun-za-uplatu',
            data: {}
        }
    },

    methods: {

        init(){
            let vm = this
            if ( vm.action === 'edit' || vm.action === 'show' ){

                axios.get( process.env.VUE_APP_API_URL + vm.url + '/' + vm.id )
                        .then( function ( response ) {
                            vm.data = response.data
                            vm.$emit( 'returnData', response.data )
                            vm.setupForm()
                        } )
                        .catch( function ( error ) {
                            if(error instanceof Error) {
                                console.log( 'Error: ' . error);
                            } else {
                                console.log( 'Unexpected response: ' . error);
                            }
                        } )

            } else if ( vm.action === 'create' ) {
                vm.data = {}
                vm.setupForm()
            } else {
                return
            }
        },

        setupForm(){

            let vm = this;

            vm.buttons = []

            let button_cancel = {
                id: 'cancel',
                title: 'Odustani',
                type: 'warning',
                action: 'redirect', // request
                config: {
                    url: vm.route + ( vm.action === 'edit' ? ( '/' + vm.id) : '' )
                }
            }

            let button_delete = {
                id: 'delete',
                title: 'Obriši',
                type: 'danger',
                action: 'request',
                config: {
                    method: 'DELETE',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let button_edit = {
                id: 'edit',
                title: 'Uredi',
                type: 'success',
                action: 'redirect',
                config: {
                    url: vm.route +  '/' + vm.id +'/edit'
                }
            }

            let button_save = {
                id: 'save',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + vm.url
                }
            }

            let button_update = {
                id: 'update',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'PUT',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let buttons = []


            if( vm.action === 'edit' ){
                buttons.push( button_cancel)
                buttons.push( button_update)
            } else if( vm.action === 'show' ) {
                buttons.push( button_cancel )
                buttons.push( button_delete )
                buttons.push( button_edit )
            }
            else if ( vm.action === 'create' ) {
                buttons.push( button_cancel )
                buttons.push( button_save )
            } else {
                return
            }

            let settings = {
                width: 6,
                modal: false,
                tabs:[
                    {
                        name: '',
                        active: true,
                        sections: [
                            {
                                name: '',
                                width: 12,
                                inputs: [
                                    {
                                        name: 'primatelj',
                                        type: 'input',
                                        title: 'Naziv',
                                        value: vm.data['primatelj'] ? vm.data['primatelj'] : '',
                                        width: 12,
                                        error: vm.errors['primatelj'] ? vm.errors['primatelj'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {} // email = true || password = true
                                    },
                                    {
                                        name: 'oib',
                                        type: 'input',
                                        title: 'OIB',
                                        value: vm.data['oib'] ? vm.data['oib'] : '',
                                        width: 12,
                                        error: vm.errors['oib'] ? vm.errors['oib'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'adresa',
                                        type: 'input',
                                        title: 'Adresa',
                                        value: vm.data['adresa'] ? vm.data['adresa'] : '',
                                        width: 12,
                                        error: vm.errors['adresa'] ? vm.errors['adresa'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'mjesto',
                                        type: 'input',
                                        title: 'Mjesto',
                                        value: vm.data['mjesto'] ? vm.data['mjesto'] : '',
                                        width: 12,
                                        error: vm.errors['mjesto'] ? vm.errors['mjesto'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'postanski_broj',
                                        type: 'input',
                                        title: 'Poštanski broj',
                                        value: vm.data['postanski_broj'] ? vm.data['postanski_broj'] : '',
                                        width: 12,
                                        error: vm.errors['postanski_broj'] ? vm.errors['postanski_broj'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'mobitel',
                                        type: 'input',
                                        title: 'Mobitel',
                                        value: vm.data['mobitel'] ? vm.data['mobitel'] : '',
                                        width: 12,
                                        error: vm.errors['mobitel'] ? vm.errors['mobitel'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'poziv_na_broj',
                                        type: 'input',
                                        title: 'Poziv na broj',
                                        value: vm.data['poziv_na_broj'] ? vm.data['poziv_na_broj'] : '',
                                        width: 12,
                                        error: vm.errors['poziv_na_broj'] ? vm.errors['poziv_na_broj'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'broj_racuna',
                                        type: 'input',
                                        title: 'Broj računa',
                                        value: vm.data['broj_racuna'] ? vm.data['broj_racuna'] : '',
                                        width: 12,
                                        error: vm.errors['broj_racuna'] ? vm.errors['broj_racuna'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'iban',
                                        type: 'input',
                                        title: 'IBAN',
                                        value: vm.data['iban'] ? vm.data['iban'] : '',
                                        width: 12,
                                        error: vm.errors['iban'] ? vm.errors['iban'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'telefon',
                                        type: 'input',
                                        title: 'Telefon',
                                        value: vm.data['telefon'] ? vm.data['telefon'] : '',
                                        width: 12,
                                        error: vm.errors['telefon'] ? vm.errors['telefon'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'mobitel',
                                        type: 'input',
                                        title: 'Mobitel',
                                        value: vm.data['mobitel'] ? vm.data['mobitel'] : '',
                                        width: 12,
                                        error: vm.errors['mobitel'] ? vm.errors['mobitel'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'fax',
                                        type: 'input',
                                        title: 'Fax',
                                        value: vm.data['fax'] ? vm.data['fax'] : '',
                                        width: 12,
                                        error: vm.errors['fax'] ? vm.errors['fax'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    },
                                    {
                                        name: 'email',
                                        type: 'input',
                                        title: 'Email',
                                        value: vm.data['email'] ? vm.data['email'] : '',
                                        width: 12,
                                        error: vm.errors['email'] ? vm.errors['email'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {}
                                    }

                                ],
                            }
                        ],
                    },
                ],
                buttons: buttons
            }

            vm.settings = settings
        },

        /**
         *  on input return data
         */
        // onInput( name, value ){
        //     console.log( 'AdministratorForma input -> ' + name + ':' , value )
        // },

        /**
         *  on button click
         */
        onFormButtonClick( id, action, config, data  ){

            if( id === 'save' || id === 'update' ){
                if( data.success){
                    if( id == 'save' )
                        toastr.success( 'Uspješno spremljeno!' )
                    else if ( id == 'update' )
                        toastr.success( 'Uspješno ažurirano!' )
                    this.$router.push({ path: this.route + '/' + data.data.id } )
                } else {
                    this.errors = data.messages
                    this.init()
                }
            } else if( id == 'delete' ){
                toastr.error( 'Uspješno obrisano!' )
                this.$router.push({ path: this.route } )
            }

        },


    },
    mounted() {
        this.init()
    }
}
</script>

<style scoped>

</style>